<script setup>
import Sugar from "sugar"
Sugar.extend({
  namespaces: [Date]
})
const { user, loggedIn, clear: clearSession } = useUserSession()
const mobile = ref(false)

async function logout() {
  await clearSession()
  await navigateTo('/login')
}
</script>
<template>
  <v-menu min-width="200px">
    <template v-slot:activator="{props}">
      <v-btn icon v-bind="props">
        <v-avatar color="">
          <v-icon>mdi-account</v-icon>
        </v-avatar>
      </v-btn>
    </template>
    <v-card>
      <v-layout>
        <v-navigation-drawer color="" :mobile="mobile">
          <v-list-item :title="user?.fullName" class="justify-center"></v-list-item>
          <v-divider></v-divider>
          <v-list>
            <v-list-item prepend-icon="mdi-account" title="帳號" disabled></v-list-item>
            <v-list-item prepend-icon="mdi-onepassword" title="變更密碼" disabled></v-list-item>
            <v-list-item prepend-icon="mdi-help" title="Help" disabled></v-list-item>
          </v-list>
          <template v-slot:append>
            <div class="pa-2">
              <v-btn block @click="logout" class="">
                登出
              </v-btn>
            </div>
          </template>
        </v-navigation-drawer>
        <v-main style="height: 255px"></v-main>
      </v-layout>
    </v-card>
  </v-menu>
</template>

<style></style>